function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepDetailsGroup = void 0;
Object.defineProperty(exports, "StepDetailsGroupController", {
  enumerable: true,
  get: function get() {
    return _StepDetailsGroupController.StepDetailsGroupController;
  }
});
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _components = require("../../components");
var _StepDetailsGroupController = require("./StepDetailsGroupController");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _reactNative = require("react-native-web");
var _styles2 = require("../../styles");
var _utils = require("../../utils");
var _StepDetailHeader = require("./StepDetailHeader");
var _models = require("../../models");
var _locales = require("../../locales");
var _images = require("../../images");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Image = (0, _react.memo)(function (props) {
  return (0, _jsxRuntime.jsxs)(_components.View, {
    children: [(0, _jsxRuntime.jsx)(_images.Splodge, {
      style: {
        position: 'absolute',
        zIndex: -1,
        bottom: 0
      },
      fill: "#fbcbc6"
    }), (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/HandsHoldingHearts.svg"),
      width: 308,
      height: 173
    }, props))]
  });
});
var StepDetailsGroup = exports.StepDetailsGroup = (0, _react.memo)(function (_ref) {
  var _action$checklistItem;
  var _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _StepDetailsGroupController.StepDetailsGroupController() : _ref$controller,
    actionParam = _ref.actionParam;
  (0, _useLang.useLang)();
  (0, _locales.useStepLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles,
    breakpoint = _useStyles.breakpoint;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS,
    improvementColors = _STYLES$useStyles.improvementColors,
    spacing = _STYLES$useStyles.spacing;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    todoListPageLinkUrl = _useContext.todoListPageLinkUrl;
  var _useContext2 = (0, _react.useContext)(_utils.AuthContext),
    isAuthenticated = _useContext2.isAuthenticated,
    login = _useContext2.login;
  var _useContext3 = (0, _react.useContext)(_utils.ConfigurationContext),
    ClientApplication = _useContext3.ClientApplication;
  var _controller$useContro = controller.useController({
      actionParam: actionParam,
      isAuthenticated: isAuthenticated
    }),
    isLoading = _controller$useContro.isLoading,
    action = _controller$useContro.action,
    commitment = _controller$useContro.commitment;
  var _shareLink = "https://zero.giki.earth/actions/".concat(action == null ? void 0 : action.param);
  var _shareCounter = (action == null ? void 0 : action.popularity) || 0;
  var _commitmentPending = (commitment == null ? void 0 : commitment.state) === _models.CommitmentState.pending;
  var _showToDoListCTA = !(0, _utils.isCommitmentStateCompleted)(commitment == null ? void 0 : commitment.state) && !!(action != null && action.checklistItems) && (action == null ? void 0 : action.checklistItems.length) > 0;
  var _hasImprovements = (action == null ? void 0 : action.improvements) && action.improvements.length > 0;
  var _hasTags = (action == null ? void 0 : action.tags) && action.tags.length > 0;
  var _hasBenefits = (action == null ? void 0 : action.benefits) && action.benefits.length > 0;
  var _hasFacts = (action == null ? void 0 : action.facts) && action.facts.length > 0;
  var _hasUsefulInformation = (action == null ? void 0 : action.informationItems) && action.informationItems.length > 0;
  var _hasTips = (action == null ? void 0 : action.tips) && action.tips.length > 0;
  var _hasResources = (action == null ? void 0 : action.resources) && action.resources.length > 0;
  var _isInteractive = action == null ? void 0 : action.interactive;
  var _showBanner = isAuthenticated && !_isInteractive || !isAuthenticated && !!(action != null && action.workStep);
  var _formatImpact = function _formatImpact() {
    return action == null ? void 0 : action.impact.name.toLowerCase();
  };
  var _formatImprovements = function _formatImprovements() {
    return action == null ? void 0 : action.improvements.map(function (improvement) {
      return improvement.toLowerCase();
    }).join(', ').replace(/, ([^,]*)$/, " & $1");
  };
  if (!actionParam) return null;
  if (isLoading || !action) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {
      testID: "ActivityIndicatorIsLoading"
    });
  }
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.Header, {
      style: styles.header,
      backgroundImage: (0, _jsxRuntime.jsx)(_components.ScreenBackgroundImage, {
        color1: '#FFB7D6',
        color2: '#E97BA3'
      }),
      contentStyle: [styles.headerContent],
      children: (0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
        value: {
          source: 'StepDetailsGroup Header'
        },
        children: (0, _jsxRuntime.jsx)(_StepDetailHeader.StepDetailHeader, {
          action: action
        })
      })
    }), (0, _jsxRuntime.jsx)(_components.View, {
      style: styles.container,
      children: (0, _jsxRuntime.jsxs)(_components.View, {
        style: [styles.content],
        children: [_showBanner && (0, _jsxRuntime.jsx)(_components.Announcements, {
          items: [{
            id: action.id,
            body: isAuthenticated ? t('stepDetailsGroup:workStepBanner.signedIn') : t('stepDetailsGroup:workStepBanner.signedOut'),
            primaryActionLabel: t('stepDetailsGroup:workStepBanner.primaryActionLabel'),
            primaryActionLink: "https://giki.earth/sustainability-at-work-programme/?utm_campaign=work_step&utm_source=".concat(action.slug, "&utm_medium=").concat(ClientApplication),
            category: t('stepDetailsGroup:workStepBanner.category'),
            backgroundColor: '#FFE8E6',
            Image: Image,
            closeable: false
          }]
        }), !_showBanner && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [(0, _jsxRuntime.jsx)(_components.Heading, {
            level: 2,
            style: styles.mainHeading,
            children: t('stepDetailsGroup:about')
          }), (0, _jsxRuntime.jsxs)(_components.View, {
            style: [styles.row, styles.sectionContainer],
            spacer: breakpoint ? spacing.l : spacing.xxl,
            children: [(0, _jsxRuntime.jsxs)(_components.View, {
              style: [styles.about],
              children: [(0, _jsxRuntime.jsx)(_components.Text, {
                textStyle: [styles.summaryText],
                containerStyle: styles.summaryTextContainer,
                children: action.summary
              }), (0, _jsxRuntime.jsx)(_components.Text, {
                containerStyle: styles.descriptionTextContainer,
                textStyle: styles.descriptionText,
                children: action.description
              })]
            }), (0, _jsxRuntime.jsxs)(_components.View, {
              style: [styles.stats],
              spacer: spacing.m,
              children: [(0, _jsxRuntime.jsx)(_components.View, {
                spacer: spacing.normal,
                children: (0, _jsxRuntime.jsx)(_components.ProgressBar, {
                  label: t('stepDetailsGroup:impact'),
                  title: t('stepDetailsGroup:impact'),
                  description: action.impact.name,
                  max: 1,
                  value: action.impact.rating / 5
                })
              }), _hasImprovements && (0, _jsxRuntime.jsxs)(_components.View, {
                style: [styles.improvements],
                children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                  style: styles.improvementsHeading,
                  children: t('stepDetailsGroup:helps')
                }), (0, _jsxRuntime.jsx)(_components.View, {
                  spacer: spacing.xs,
                  children: action.improvements.map(function (improvement) {
                    return (0, _jsxRuntime.jsxs)(_components.View, {
                      style: [styles.improvementItem],
                      children: [(0, _jsxRuntime.jsx)(_components.View, {
                        style: [styles.dot, {
                          backgroundColor: improvementColors[improvement]
                        }]
                      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
                        style: [styles.improvementItemText],
                        children: t("stepDetailsGroup:".concat(improvement))
                      })]
                    }, improvement);
                  })
                })]
              }), _hasTags && (0, _jsxRuntime.jsxs)(_components.View, {
                style: [styles.where],
                spacer: spacing.s,
                children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                  style: styles.whereHeading,
                  children: t('stepDetailsGroup:where')
                }), (0, _jsxRuntime.jsx)(_components.View, {
                  style: [styles.tags],
                  spacer: spacing.xxs,
                  children: action.tags.map(function (tag) {
                    return (0, _jsxRuntime.jsx)(_components.CategoryPill, {
                      label: tag,
                      backgroundColor: COLORS.mushroom,
                      textColor: COLORS.aubergine
                    }, tag);
                  })
                })]
              })]
            })]
          }), _showToDoListCTA && (0, _jsxRuntime.jsx)(_components.View, {
            style: [styles.sectionContainer],
            children: (0, _jsxRuntime.jsxs)(_components.ToDoListCTA, {
              children: [(0, _jsxRuntime.jsx)(_components.BenefitsList, {
                style: {
                  marginBottom: spacing.l
                },
                items: (_action$checklistItem = action.checklistItems) == null ? void 0 : _action$checklistItem.sort(function (item1, item2) {
                  if (item1.order > item2.order) return 1;
                  if (item1.order < item2.order) return -1;
                  return 0;
                }).map(function (item) {
                  return item.description;
                })
              }), (0, _jsxRuntime.jsxs)(_components.View, {
                style: {
                  alignItems: 'flex-start'
                },
                children: [!isAuthenticated && login && (0, _jsxRuntime.jsx)(_components.Button, {
                  type: _components.ButtonType.brand,
                  label: t('step:buttons.commit'),
                  onPress: login
                }), isAuthenticated && _commitmentPending && !!todoListPageLinkUrl && (0, _jsxRuntime.jsx)(_components.Button, {
                  type: _components.ButtonType.outlined,
                  label: t('step:buttons.todoList'),
                  href: (0, _utils.ReplaceParam)(todoListPageLinkUrl, commitment.id)
                }), isAuthenticated && !_commitmentPending && _isInteractive && (0, _jsxRuntime.jsx)(_utils.AnalyticsSourceContext.Provider, {
                  value: {
                    source: 'StepDetailsGroup ToDoListCTA'
                  },
                  children: (0, _jsxRuntime.jsx)(_components.StepButtons.Commit, {
                    action: action,
                    type: _components.ButtonType.brand
                  })
                })]
              })]
            })
          }), _hasBenefits && (0, _jsxRuntime.jsx)(_components.BulletList, {
            style: styles.sectionContainer,
            title: t('stepDetailsGroup:reasons'),
            items: action.benefits.map(function (item) {
              return item.description;
            }),
            bulletColor: COLORS.cherry
          }), (_hasUsefulInformation || _hasTips || _hasFacts) && (0, _jsxRuntime.jsxs)(_components.View, {
            style: styles.sectionContainer,
            spacer: spacing.xxl,
            children: [_hasUsefulInformation && (0, _jsxRuntime.jsx)(_components.BulletList, {
              title: t('stepDetailsGroup:usefulToKnow'),
              items: action.informationItems.map(function (info) {
                return info.description;
              }),
              bulletColor: COLORS.money
            }), _hasTips && (0, _jsxRuntime.jsx)(_components.BulletList, {
              title: t('stepDetailsGroup:tips'),
              items: action.tips.map(function (info) {
                return info.description;
              }),
              bulletColor: COLORS.water
            }), _hasFacts && (0, _jsxRuntime.jsx)(_components.BulletList, {
              title: t('stepDetailsGroup:facts'),
              items: action.facts.map(function (info) {
                return info.description;
              }),
              bulletColor: COLORS.health
            })]
          }), _hasResources && (0, _jsxRuntime.jsxs)(_components.View, {
            style: styles.sectionContainer,
            children: [(0, _jsxRuntime.jsx)(_components.Heading, {
              level: 3,
              style: styles.H3,
              children: t('stepDetailsGroup:usefulLinks')
            }), (0, _jsxRuntime.jsx)(_components.View, {
              spacer: spacing.normal,
              children: action.resources.sort(function (a, b) {
                return a.order > b.order ? 1 : -2;
              }).map(function (resource) {
                return (0, _jsxRuntime.jsx)(_components.ResourceCard, {
                  title: resource.title,
                  category: resource.category,
                  linkUrl: resource.url
                }, resource.id);
              })
            })]
          }), (0, _jsxRuntime.jsx)(_components.ShareStepCTA, {
            text: t('stepDetailsGroup:shareText', {
              impact: _formatImpact(),
              improvements: _formatImprovements()
            }),
            stepName: action == null ? void 0 : action.name,
            url: _shareLink,
            counter: _shareCounter
          })]
        })]
      })
    })]
  });
});